import { ScrewGroup, Screw } from "@scene/objects/screw";
import { initState as initDimensionState, imperialState, metricState } from "@reducers/selectors/dimension";
import { APP_TYPES } from "@config";
import { mergeDeep } from "@services/helper.service";

export const GeneralCalculationState = {
  count: {
    n: 2, // Use triangle, square and circle
    m: 2, // Use triangle, square
    k: 0, // Use triangle
    ignorePositions: [] // For square, e.g. ignore center screw position
  },
  outside: {
    state: false,
    data: []
  },
  customLayout: false,
  custom: {
    allow: false, // If user select n type screws
    active: false, // If user select specify coordinated
    positions: [] // Container screws positions
  },
  heightType: Screw.types.height.DEFAULT,
  types: [],
  padding: {
    // For triangle
    s: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.s,
    // For square
    s1: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.s1,
    s2: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.s2,
    // For circle
    diameter: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.d
  },
  coordinatesList: [], // Contain screw coordinates
  radius: 6,
  formation: ScrewGroup.formation.NOT_SET,
  vertical: false // For linear formation only
};

export function getGeneralCalcDefault(isImperial) {
  let unitState = isImperial ? imperialState : metricState;
  return mergeDeep({}, GeneralCalculationState, { 
    padding: {
      // For triangle
      s: unitState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.s,
      // For square
      s1: unitState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.s1,
      s2: unitState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.s2,
      // For circle
      diameter: unitState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.d
    }
  });
}



// WEBPACK FOOTER //
// ./src/reducers/options/screw/defaults/generalCalculation.js